import React, { useEffect, useState } from 'react';
import {
  Button,
  Input,
  DatePicker,
  Overlay,
  Form,
  Select,
  Table,
  Radio,
  Notification,
  Dialog,
  Progress,
  Balloon,
} from '@alifd/next';
import moment from 'moment';
import styles from './index.module.scss';
import LzMsg from '@/components/common/LzMsg';
import { CanvasService } from '@/service';

function SecondaryMarketCrowd(props) {
  const { Tooltip } = Balloon;
  // 人群选择
  const [crowdChoose, setCrowdChoose] = useState(1);
  // 人群名称
  const [crowdName, setCrowdName] = useState();
  // 人群描述
  const [crowdDesc, setCrowdDesc] = useState();
  // 人群数量
  const [crowdAmount, setCrowdAmount] = useState(1000);
  // 人群包实例ID strategyInstId  和 结果策略ID resultStrategyInstId
  const [SmsResultids, setResultids] = useState({
    strategyInstId: '',
    resultStrategyInstId: '',
    taskId: '',
    taskInstId: '',
    prepNum: 1,
    realNum: 1,
  });
  const [progressData, setProgressData] = useState([]);

  const confirmGenerate = () => {
    const names = [];
    progressData.forEach((item) => {
      names.push(item.crowdName);
    });
    if (!crowdName) {
      LzMsg.error('请填写二次营销人群名称');
    } else if (names.includes(crowdName)) {
      LzMsg.error('人群名不可重复');
    } else if (crowdChoose === 1 && SmsResultids.prepNum === 0) {
      LzMsg.error('人群数量为0，无法生成二次人群');
    } else if (crowdChoose === 2 && SmsResultids.realNum === 0) {
      LzMsg.error('人群数量为0，无法生成二次人群');
    } else if (
      crowdChoose === 3 &&
      Number(SmsResultids.prepNum) - Number(SmsResultids.realNum) === 0
    ) {
      LzMsg.error('人群数量为0，无法生成二次人群');
    } else if (crowdChoose >= 4 && SmsResultids.realNum === 0) {
      LzMsg.error('人群数量为0，无法生成二次人群');
    } else if (!SmsResultids.resultStrategyInstId) {
      LzMsg.error('此任务结果包未发送成功');
    } else {
      const param = {
        crowdDescription: crowdDesc,
        crowdName: crowdName,
        crowdSelection: crowdChoose,
        resultStrategyInstId: SmsResultids.resultStrategyInstId
          ? SmsResultids.resultStrategyInstId
          : '',
        sendTime: props.record.sendTime
          ? props.record.sendTime.toString()
          : props.record.launchTime.toString(),
        strategyInstId: SmsResultids.strategyInstId
          ? SmsResultids.strategyInstId
          : '',
        taskId: SmsResultids.taskId,
        taskInstId: SmsResultids.taskInstId,
      };
      CanvasService.saveSecondaryMarketingCrowd(param)
        .then((res) => {
          if (res.data === true) {
            LzMsg.success('人群创建成功');
            // 创建成功 刷新下面进度条数据
            getSecondaryMarketingCrowd();
          } else {
            LzMsg.error('人群创建失败，请重新创建或联系管理员');
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };
  //  获取 进度条 数据
  const getSecondaryMarketingCrowd = () => {
    CanvasService.getSecondaryMarketingCrowd({
      taskInstId: props.record.taskInstId,
    })
      .then((res) => {
        setProgressData(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  // 获取 人群包实例ID strategyInstId  和 结果策略ID resultStrategyInstId
  useEffect(() => {
    CanvasService.getSmsResultids({
      taskInstId: props.record.taskInstId,
      taskType: props.record.taskType || 4,
    })
      .then((res) => {
        // 临时注掉
        setResultids({ ...SmsResultids, ...res.data });
      })
      .catch((e) => {
        console.log(e);
      });
    getSecondaryMarketingCrowd();
  }, []);
  return (
    <div>
      <div className={styles.container}>
        {/* 提示 */}
        <div className={styles.notice}>
          <div style={{ width: '20px' }}>
            <span
              className="iconfont  icon-icon4-38"
              style={{ color: '#3399FF' }}
            />
          </div>
          <div style={{ marginLeft: '8px' }}>
            <div style={{ width: '100%' }}>提示：</div>
            <div style={{ width: '100%' }}>
              1.已发送成功的活动，可以提取其成功触达的人群，在我的人群库中生成新人群并进行营销。
            </div>
            <div style={{ width: '100%' }}>
              2.人群生成需要时间，请耐心等待,人群生成中可以关闭窗口。
            </div>
            <div style={{ width: '100%' }}>
              3.
              {/* 保存成功的人群会生成在用户人群-人群列表中， */}
              {/* 所有生成的人群会带有<img width="20px" height="20px" src="//img10.360buyimg.com/imgzone/jfs/t1/143243/7/2913/1251/5f0bd9ccE0b9c1d1f/06a714d9d7f6c262.png"></img>标识 */}
              保存成功的人群会生成在我的人群库-人群包列表中，所生成的人群包类型为二次营销。
              {/* 选择全部客户保存时会带有<img width="20px" height="20px" src="//img10.360buyimg.com/imgzone/jfs/t1/143243/7/2913/1251/5f0bd9ccE0b9c1d1f/06a714d9d7f6c262.png"></img>标识。 */}
            </div>
            <div style={{ width: '100%' }}>
              4.二次发送人群筛选会因为其他营销行为造成的用户成交而导致筛选结果不够精准。因此建议如需生成二次发送人群的话，可在营销后3-7天进行，数据相对较为精准。
            </div>
          </div>
        </div>
        {/* 提示结束 */}
        {/* 二次营销人群选择 */}
        <div className={styles.crowdChoose}>
          <div style={{ width: '100%' }}>
            <span style={{ color: 'red' }}>*</span>二次营销人群选择：
          </div>
          <div style={{ width: '100%', marginTop: '10px' }}>
            <Radio.Group
              direction="hoz"
              value={crowdChoose}
              style={{ display: 'flex' }}
              onChange={(value) => {
                setCrowdChoose(value), setCrowdName('');
              }}
            >
              <Radio value={1} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>原营销人群包</span>
              </Radio>
              <Radio value={2} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>本次营销成功人群</span>
              </Radio>
              <Radio value={3} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>本次未营销人群</span>
              </Radio>
              <Radio value={4} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>下单用户</span>
              </Radio>
              <Radio value={5} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>未下单用户</span>
              </Radio>
              <Radio value={6} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>付款用户</span>
              </Radio>
            </Radio.Group>
          </div>
        </div>
        {/* 二次营销人群选择结束 */}
        {/* 二次营销人群名称 */}
        <div className={styles.crowdName}>
          <div style={{ width: '100%' }}>
            <span style={{ color: 'red' }}>*</span>二次营销人群名称：
          </div>
          <div style={{ marginTop: '10px' }}>
            <Input
              style={{ width: '100%' }}
              name="crowddes"
              maxLength={32}
              onChange={(value) => {
                setCrowdName(value);
              }}
              value={crowdName}
              showLimitHint
              aria-label="input max length 32"
            />
          </div>
        </div>
        {/* 二次营销人群名称结束 */}
        {/* 二次营销人群描述 */}
        <div className={styles.crowdDesc}>
          <div>二次营销人群描述：</div>
          <div style={{ marginTop: '10px' }}>
            <Input
              style={{ width: '100%' }}
              name="crowddes"
              maxLength={32}
              onChange={(value) => {
                setCrowdDesc(value);
              }}
              value={crowdDesc}
              showLimitHint
              aria-label="input max length 32"
            />
          </div>
        </div>
        {/* 二次营销人群描述结束 */}
        {/*  人群数量 */}
        <div className={styles.crowdAmount}>
          <div style={{ width: '100%', display: 'flex' }}>
            <div style={{ flex: 1 }}>
              {/* 原 预计  prepNum
                  本次营销成功人群  实际   realNem
                  本次未营销人群  预计 - 实际  prepNum - realNem
                  后三个   小于  实际     小于realNem
              */}
              人群数量：
              {crowdChoose === 1 && (
                <span>{Number(SmsResultids.prepNum).toLocaleString()}</span>
              )}
              {crowdChoose === 2 && (
                <span>{Number(SmsResultids.realNum).toLocaleString()}</span>
              )}
              {crowdChoose === 3 && (
                <span>
                  {(
                    Number(SmsResultids.prepNum) - Number(SmsResultids.realNum)
                  ).toLocaleString()}
                </span>
              )}
              {crowdChoose === 4 && (
                <span>小于{Number(SmsResultids.realNum).toLocaleString()}</span>
              )}
              {crowdChoose === 5 && (
                <span>小于{Number(SmsResultids.realNum).toLocaleString()}</span>
              )}
              {crowdChoose === 6 && (
                <span>小于{Number(SmsResultids.realNum).toLocaleString()}</span>
              )}
            </div>
            <div style={{ flex: 1, textAlign: 'right' }}>
              <Button
                type="primary"
                style={{ width: '88px', height: '30px', padding: 0 }}
                onClick={() => {
                  confirmGenerate();
                }}
              >
                确认生成
              </Button>
            </div>
          </div>
        </div>
        {/*  人群数量结束 */}
        {/*  人群生成进度 */}
        <div style={{ marginTop: '27px' }}>
          人群生成进度(只显示当天进度记录):
        </div>
        <div className={styles.crowdProgress}>
          <div style={{ height: '230px', overflow: 'auto' }}>
            <div className={styles.progeressCon}>
              {progressData.map((item, index) => {
                return (
                  <div key={`${index}${'div'}`}>
                    <div style={{ marginBottom: '10px' }}>
                      {/* {item.crowdSelection === 1 && <span>原营销人群包</span>}
                        {item.crowdSelection === 2 && <span>本次营销成功人群</span>}
                        {item.crowdSelection === 3 && <span>本次未营销人群</span>}
                        {item.crowdSelection === 4 && <span>下单用户</span>}
                        {item.crowdSelection === 5 && <span>未下单用户</span>}
                        {item.crowdSelection === 6 && <span>付款用户</span>}
                        : */}
                      {item.crowdName}
                    </div>
                    <div style={{ display: 'flex' }} key={`${'pr'}${index}`}>
                      <Progress
                        percent={20 * item.stepFlag}
                        progressive
                        style={{ width: '95%', marginBottom: '25px' }}
                        key={`${'progress'}${index}`}
                        color={
                          item.stepFlag === 5
                            ? '#00bb66'
                            : item.stepFlag === 0
                            ? '#ff3333'
                            : '#3399ff'
                        }
                      />
                      <div style={{ width: '5%' }} key={`${'div'}${index}`}>
                        {Number(item.stepFlag) === 5 && (
                          <span
                            style={{ color: '#00BB66' }}
                            key={`${index}${'succ'}`}
                          >
                            成功
                          </span>
                        )}
                        {Number(item.stepFlag) === 0 && (
                          <div>
                            <span
                              style={{ color: '#FF3333' }}
                              key={`${index}${'succ'}`}
                            >
                              失败:
                            </span>
                            <Tooltip
                              align="t"
                              trigger={
                                <span
                                  style={{
                                    fontSize: '14px',
                                    marginLeft: '4px',
                                    cursor: 'pointer',
                                  }}
                                  className="iconfont icon-icon4-33"
                                />
                              }
                            >
                              {item.failureReason}
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <hr />
      {/*  人群生成进度结束 */}
      <div style={{ margin: '20px 30px 15px 0', textAlign: 'right' }}>
        <Button
          type="normal"
          onClick={() => {
            props.secondaryClose();
          }}
          style={{ width: '88px', height: '30px' }}
        >
          关闭
        </Button>
      </div>
    </div>
  );
}

export default SecondaryMarketCrowd;
